/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import savedContactsPreviewStyles from './saved-contacts-preview.styles';
import userPlaceholder from '../../assets/user_placeholder.png';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { UpdateContacts } from '../update-contacts/update-contacts.component';

type Props = {
    phone?: string;
    email?: string;
    transactionId: string;
};

const SavedContactsPreview = (props: Props) => {
    const { phone, email, transactionId } = props;
    const intl = useIntl();
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    if (!phone) {
        return null;
    }

    return (
        <>
            <div css={savedContactsPreviewStyles.container}>
                <div css={savedContactsPreviewStyles.letfBlock}>
                    <img src={userPlaceholder} css={savedContactsPreviewStyles.userPlaceholder} />
                    <div css={savedContactsPreviewStyles.informationBlock}>
                        <p css={savedContactsPreviewStyles.userContacts}>{email}</p>
                        <p css={savedContactsPreviewStyles.userContacts}>{phone}</p>
                    </div>
                </div>
                <div css={savedContactsPreviewStyles.rightBlock}>
                    <Button
                        variant="outlined"
                        sx={{
                            border: 'none',
                            boxShadow: 'none',
                            textTransform: 'capitalize',
                            color: '#004FC6',
                            fontSize: '14px',
                            fontWeight: 600,
                            paddingRight: 0,
                        }}
                        onClick={() => {
                            setIsEditModalOpen(true);
                        }}>
                        {intl.formatMessage({ id: 'edit' })}
                    </Button>
                </div>
            </div>
            <UpdateContacts
                transactionId={transactionId}
                phone={phone}
                email={email}
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                onOpen={() => setIsEditModalOpen(true)}
            />
        </>
    );
};

export default SavedContactsPreview;
